import useCachedSelectionList from '../base/useCachedList';
import { useFindCategoryForSelectionLazy } from './useFindCategoriesForSelection';

const useCachedCategoriesList = () => {
  return useCachedSelectionList(
    'categoryList',
    useFindCategoryForSelectionLazy
  );
};

export default useCachedCategoriesList;
